{
"columns":[
		{
			"header_id": "tasBillingBatchClaimDetailId",
			"header_label": "Batch claim detail Id",
			"jsonpath":  "tasBillingBatchClaimDetailId" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "tasBillingBatchMasterId",
			"header_label": "Batch master Id",
			"jsonpath":  "tasBillingBatchMasterId" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "parentClaimDetailId",
			"header_label": "Parent CLaim detail Id",
			"jsonpath":  "parentClaimDetailId" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "adjustedClaimDetailId",
			"header_label": "Adjuste claim detail Id",
			"jsonpath":  "adjustedClaimDetailId" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "pplIcn",
			"header_label": "PPL Icon",
			"jsonpath":  "pplIcn" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "extIcn",
			"header_label": "External Icon",
			"jsonpath":  "extIcn" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "participantId",
			"header_label": "Participant Id",
			"jsonpath":  "participantId" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "mcoParticipantId",
			"header_label": "MCO participant Id",
			"jsonpath":  "mcoParticipantId" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "medicaidParticipantId",
			"header_label": "Medicaid Participant Id",
			"jsonpath":  "medicaidParticipantId" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "participantCounty",
			"header_label": "Participant County",
			"jsonpath":  "participantCounty" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "diagnosisCode",
			"header_label": "Diagnosis Code",
			"jsonpath":  "diagnosisCode" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "serviceCode",
			"header_label": "Service Code",
			"jsonpath":  "serviceCode" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "modifierCode",
			"header_label": "Modifier Code",
			"jsonpath":  "modifierCode" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "serviceDate",
			"header_label": "Service Date",
			"jsonpath":  "serviceDate" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "units",
			"header_label": "Units",
			"jsonpath":  "units" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "timesheets",
			"header_label": "Timesheets",
			"jsonpath":  "timesheets" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "timesheetsCount",
			"header_label": "Timesheets count",
			"jsonpath":  "timesheetsCount" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "billableRate",
			"header_label": "Billable Rate",
			"jsonpath":  "billableRate" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "totalCharges",
			"header_label": "Total Charges",
			"jsonpath":  "totalCharges" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "mcoName",
			"header_label": "MCO Name",
			"jsonpath":  "mcoName" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "providerId",
			"header_label": "Provider Id",
			"jsonpath":  "providerId" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "authNumber",
			"header_label": "Auth Number",
			"jsonpath":  "authNumber" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "frequencyCode",
			"header_label": "Frequency Code",
			"jsonpath":  "frequencyCode" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "status",
			"header_label": "Status",
			"jsonpath":  "status" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "sysVoidFlg",
			"header_label": "System Void",
			"jsonpath":  "sysVoidFlg" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		}
    ],
  "buttons": [],
  "apiDetails": "claims.json",
  "pageName": "billingClaimsListView",
  "orderByColumn": ["createddate"],
  "orderBy": ["desc"]
}
